import { render } from "./DegreesView.vue?vue&type=template&id=6519aec4&scoped=true"
import script from "./DegreesView.vue?vue&type=script&lang=js"
export * from "./DegreesView.vue?vue&type=script&lang=js"

import "./DegreesView.vue?vue&type=style&index=0&id=6519aec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6519aec4"]])

export default __exports__